import React from 'react';
import PropTypes from 'prop-types';
import Table from '../base/Table/BootstrapTable';
import TableColumn from '../base/Table/BootstrapTableColumn';
import {IS_INTERNAL_APP} from '../../api/ApiSettings';
import textTranslates from './translate.json';

const CompanyResultTable = (props) => {
    return(
        <div className="col-xs-12">
            <Table
                data={props.companies}
                keyField="id"
                pageChanged={props.onPageChanged}
                selectedIndex={props.selectedIndex}
                selectedPage={props.selectedPage}
                selectedRowChanged={props.selectedRowChanged} >
                <TableColumn
                    dataField="companyName"
                    label={textTranslates.companyNameHeaderCaption}
                    width="30%" />
                {/* {IS_INTERNAL_APP === true &&
                    <TableColumn
                        dataField="code"
                        label={textTranslates.companyCodeHeaderCaption}
                        width="25%" /> } */}
                <TableColumn
                    dataField="city"
                    label={textTranslates.companyCityHeaderCaption}
                    width="15%" />
                <TableColumn
                    dataField="fullAddress"
                    label={textTranslates.companyStreetHeaderCaption}
                    width="30%" />
            </Table>
        </div>
    );
};


CompanyResultTable.propTypes = {
    companies: PropTypes.array,
    onPageChanged: PropTypes.func,
    selectedIndex: PropTypes.number,
    selectedPage: PropTypes.number,
    selectedRowChanged: PropTypes.func
};

export default CompanyResultTable;


// WEBPACK FOOTER //
// ./src/components/Company/CompanyResultTable.js